if (window.innerWidth <= 768) {
  document.addEventListener('DOMContentLoaded', function() {
    const mobileVideos = document.querySelectorAll('.video--mobile video');
    
    mobileVideos.forEach(video => {
      video.muted = true;
      video.playsInline = true;
      video.autoplay = true;
      
      video.play().catch(err => {
        console.log('Autoplay blocked, trying after touch:', err);
        document.body.addEventListener('touchstart', function() {
          video.play();
        }, { once: true });
      });
    });
  });
}